import styled, { css } from 'styled-components';
import { Column, Columns } from '../../components/base/grid';
import { Tab } from '../../components/base/tabs/tabs';
import { fadeIn } from '../../constants/keyframes/fades';
import media from '../../constants/media';
import zIndex from '../../constants/zIndex';

export const Wrapper = styled.div``;

export const PostOfficesWrapper = styled.div``;

type InfoListColumnProps = {
	$activeMobileView?: 'list' | 'map';
	$mobileView?: 'list' | 'map';
};

export const InfoListColumn = styled(Column)<InfoListColumnProps>`
	${media.mobileAndTabletOnly`
		${({ $activeMobileView, $mobileView }) =>
			$activeMobileView &&
			$mobileView &&
			$activeMobileView !== $mobileView &&
			css`
				display: none;
			`};
	`};
`;

export const ListWrapper = styled.div``;

export const MapWrapper = styled.div`
	height: 1000px;
	position: relative;
	z-index: 0;

	${media.mobileAndTabletOnly`
		height: calc(100vh - ${({ theme }) => theme.toolbars.mobileToolbarHeight} - ${({ theme }) =>
		theme.toolbars.openingTimesToolbarHeight});
		height: calc(100dvh - ${({ theme }) => theme.toolbars.mobileToolbarHeight} - ${({ theme }) =>
		theme.toolbars.openingTimesToolbarHeight});
		min-height: 36rem;
		margin-top: 1.5rem;
		margin-left: -1.5rem;
		margin-right: -1.5rem;
	`};
`;

export const Container = styled.div`
	padding: 3rem 0 !important;
`;

export const ViewColumns = styled(Columns)`
	display: flex;

	${media.desktopSmall`
		flex-wrap: nowrap;
		overflow: hidden;
	`};
`;

export const ContentTab = styled(Tab)`
	padding: 0rem;
	margin-right: 4rem;
`;

export const RegionSelect = styled.select`
	font-size: 1.6rem;
	flex-grow: 1;
	height: 5rem;
	background-color: white;
	color: ${({ theme }) => theme.colors.grayDarker};
`;

export const RegionOption = styled.option`
	color: ${({ theme }) => theme.colors.grayDarker};
`;

export const InputWrapper = styled.div`
	display: flex;
	border-bottom: 1px solid ${({ theme }) => theme.colors.borderColor};

	${media.mobileOnly`
		display: block;
	`};
`;

export const SearchInputWrapper = styled.div`
	position: relative;
	width: 100%;

	svg {
		position: absolute;
		top: 50%;
		right: 4rem;
		transform: translateY(-50%);
		color: ${({ theme }) => theme.colors.primary};
		pointer-events: none;
	}

	${media.mobileOnly`
		border-top: 1px solid ${({ theme }) => theme.colors.borderColor};
	`};
`;

export const SelectWrapper = styled.div`
	font-size: 2rem;
	${media.tablet`
        font-size: 1.7rem;
    `};
`;

export const SearchInput = styled.input`
	width: 100%;
	padding: 2.4rem 0 2.4rem 1rem;
	font-size: 2rem;

	${media.tablet`
		padding: 2.4rem;
        font-size: 1.8rem;
	`};
`;

export const MobileViewToggle = styled.div`
	position: fixed;
	left: 0;
	bottom: ${({ theme }) => theme.toolbars.mobileToolbarHeight};
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: ${({ theme }) => theme.toolbars.openingTimesToolbarHeight};
	background-color: ${({ theme }) => theme.colors.gray};
	color: #fff;
	z-index: ${zIndex.mobileToolbar};
	opacity: 0;
	animation: ${fadeIn} 400ms ease forwards;
	animation-delay: 1200ms;

	${media.desktopSmall`
		display: none;
	`};
`;

export const MobileViewToggleContent = styled.div`
	display: flex;
	align-items: center;
`;

export const MobileViewToggleText = styled.div`
	margin-top: 0.4rem;
	margin-left: 1rem;
`;
